"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureMonaco = void 0;
var language_service_1 = require("@cucumber/language-service");
var monacoEditor = __importStar(require("monaco-editor/esm/vs/editor/editor.api"));
var vscode_languageserver_types_1 = require("vscode-languageserver-types");
function configureMonaco(monaco, index, expressions) {
    monaco.languages.register({ id: 'gherkin' });
    // Syntax Highlighting (Semantic Tokens)
    monaco.languages.registerDocumentSemanticTokensProvider('gherkin', {
        getLegend: function () {
            return {
                tokenTypes: language_service_1.semanticTokenTypes,
                tokenModifiers: [],
            };
        },
        releaseDocumentSemanticTokens: function () {
            // no-op
        },
        provideDocumentSemanticTokens: function (model) {
            var gherkinSource = model.getValue();
            var tokens = (0, language_service_1.getGherkinSemanticTokens)(gherkinSource, expressions);
            var data = new Uint32Array(tokens.data);
            return {
                data: data,
            };
        },
    });
    // Auto-Complete
    monaco.languages.registerCompletionItemProvider('gherkin', {
        provideCompletionItems: function (model, position) {
            var gherkinSource = model.getValue();
            var completionItems = (0, language_service_1.getGherkinCompletionItems)(gherkinSource, toPosition(position), index);
            return {
                suggestions: completionItems.map(function (completionItem) { return ({
                    label: completionItem.label,
                    kind: monaco.languages.CompletionItemKind.Text,
                    insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                    insertText: completionItem.textEdit.newText,
                    range: toIRange(completionItem.textEdit.range),
                }); }),
            };
        },
    });
    // Document Formatting
    monaco.languages.registerDocumentFormattingEditProvider('gherkin', {
        provideDocumentFormattingEdits: function (model) {
            var gherkinSource = model.getValue();
            var textEdits = (0, language_service_1.getGherkinFormattingEdits)(gherkinSource);
            return textEdits.map(function (textEdit) { return ({
                range: toIRange(textEdit.range),
                text: textEdit.newText,
            }); });
        },
    });
    return function (editor) {
        // Diagnostics (Syntax validation)
        function setDiagnosticMarkers() {
            var model = editor.getModel();
            if (model) {
                var gherkinSource = model.getValue();
                var diagnostics = (0, language_service_1.getGherkinDiagnostics)(gherkinSource, expressions);
                var markers = diagnostics.map(function (diagnostic) {
                    return __assign(__assign({}, toIRange(diagnostic.range)), { severity: toSeverity(diagnostic.severity), message: diagnostic.message });
                });
                monaco.editor.setModelMarkers(model, 'gherkin', markers);
            }
        }
        function requestValidation() {
            window.requestAnimationFrame(function () {
                setDiagnosticMarkers();
            });
        }
        requestValidation();
        var validationTimeout;
        editor.onDidChangeModelContent(function () {
            clearTimeout(validationTimeout);
            validationTimeout = setTimeout(requestValidation, 500);
        });
    };
}
exports.configureMonaco = configureMonaco;
function toIRange(range) {
    return {
        startLineNumber: range.start.line + 1,
        startColumn: range.start.character + 1,
        endLineNumber: range.end.line + 1,
        endColumn: range.end.character + 1,
    };
}
function toPosition(position) {
    return {
        line: position.lineNumber - 1,
        character: position.column - 1,
    };
}
// https://github.com/microsoft/monaco-editor/blob/c49fdf9f0c131909ca1b661ca3ff4113c42f1c09/src/language/common/lspLanguageFeatures.ts#L121C1-L134C2
function toSeverity(lsSeverity) {
    switch (lsSeverity) {
        case vscode_languageserver_types_1.DiagnosticSeverity.Error:
            return monacoEditor.MarkerSeverity.Error;
        case vscode_languageserver_types_1.DiagnosticSeverity.Warning:
            return monacoEditor.MarkerSeverity.Warning;
        case vscode_languageserver_types_1.DiagnosticSeverity.Information:
            return monacoEditor.MarkerSeverity.Info;
        case vscode_languageserver_types_1.DiagnosticSeverity.Hint:
            return monacoEditor.MarkerSeverity.Hint;
        default:
            return monacoEditor.MarkerSeverity.Info;
    }
}
//# sourceMappingURL=configureMonaco.js.map